import { Grid, Tooltip } from '@mui/material';
import { IComponentCss, UseFetchDataState } from '@tap/mui-ui';
import { IconButton } from '@mui/material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { IApiRelationLink, relationLinkService } from '@tap/data-providers';
import { useFetchData } from '@tap/mui-ui';
import { RelationLinkCreateDialog } from './RelationLinkCreateDialog';
import { RelationLinkList } from './RelationLinkList';
import RelationLinkDeleteDialog from './RelationLinkDeleteDialog';
import { useDialog, ICancelDialogResult } from '@tap/tap-ui';

/**
 *  Связанные документы
 */

type IUseRelationLinksProps = {
    documentKey: string,
}

type IRelationLinksProps = {
    documentKey: string,
    relationLinksState: UseFetchDataState<IApiRelationLink[]>,
}

const css: IComponentCss = {
    list: {
        paddingTop: '8px',
        position: 'relative',
    },
    addButton: {
        position: 'absolute',
        right: 0,
        top: '-34px',
    },
}

export const useRelationLinks = ({
    documentKey,
}: IUseRelationLinksProps) => {

    const [relationLinksState] = useFetchData(() => relationLinkService.getRelationLinkList(documentKey), [documentKey]);

    const RelationLinksJsx = <>
        <RelationLinks
            documentKey={documentKey}
            relationLinksState={relationLinksState}
        />
    </>;

    return { RelationLinksJsx, relationLinksState };
}

export const RelationLinks = ({
    documentKey,
    relationLinksState,
}: IRelationLinksProps) => {

    const handleCloseDialog = ({ isCancel }: ICancelDialogResult) => {
        if (!isCancel) {
            relationLinksState.fetchData();
        }
    };

    const RelationLinkCreateReadyDialog = useDialog(RelationLinkCreateDialog, handleCloseDialog);
    const RelationLinkDeleteReadyDialog = useDialog(RelationLinkDeleteDialog, handleCloseDialog);

    return (
        <>
            <Grid container sx={css.list}>

                <Tooltip title='Добавить связь'>
                    <IconButton
                        size='small'
                        sx={css.addButton}
                        onClick={() => RelationLinkCreateReadyDialog.open({ documentKey: documentKey })}
                    >
                        <AddOutlinedIcon />
                    </IconButton>
                </Tooltip>

                <RelationLinkList
                    items={relationLinksState.data || []}
                    handleClickOnDeleteLinkBtn={(link) => RelationLinkDeleteReadyDialog.open({ link })}
                />
            </Grid>

            <RelationLinkCreateReadyDialog.Component />
            <RelationLinkDeleteReadyDialog.Component />
        </>
    );
}
